import { createRouter, createWebHashHistory } from 'vue-router'
const HomePage = () => import('@/pages/HomePage.vue')
const NewsVolumeList = () => import('@/pages/chart/NewsVolumeList.vue')
const TopicWeeklyStories = () => import('@/pages/chart/TopicWeeklyStories.vue')
const NewsExplorer = () => import('@/pages/chart/NewsExplorer.vue')
const NewsOrgsWeeklyStatsBase = () => import('@/pages/chart/NewsOrgsWeeklyStatsBase.vue')
const NewsOrgsWeeklyStatsBaseLastWeeks = () => import('@/pages/chart/NewsOrgsWeeklyStatsBaseLastWeeks.vue')
const NewsOrgsWeeklyStatsExtended = () => import('@/pages/chart/NewsOrgsWeeklyStatsExtended.vue')
const ConceptsPage = () => import('@/pages/ontology/concepts/ConceptsPage.vue')
const IssuersPage = () => import('@/pages/issuers/IssuersPage.vue')
const IssuerViewPage = () => import('@/pages/issuers/IssuerViewPage.vue')
const RegionalUnionsPage = () => import('@/pages/regulations/regional_unions/RegionalUnionsPage.vue')
const RegionalUnionsViewPage = () => import('@/pages/regulations/regional_unions/RegionalUnionsViewPage.vue')
const InitiativesHomePage = () => import('@/pages/regulations/initiatives/InitiativesHomePage.vue')
const InitiativeViewPage = () => import('@/pages/regulations/initiatives/InitiativeViewPage.vue')
const ValidatedInitiativesPage = () => import('@/pages/regulations/initiatives/ValidatedInitiativesPage.vue')
const InstancesPage = () => import('@/pages/infrastructure/instances/InstancesPage.vue')
const DeploymentsPage = () => import('@/pages/infrastructure/DeploymentsPage.vue')
const DeploymentAlertsPage = () => import('@/pages/infrastructure/DeploymentAlertsPage.vue')
const DeploymentAlertsView = () => import('@/pages/infrastructure/DeploymentAlertsView.vue')
const FeaturesPage = () => import('@/pages/features/FeaturesPage.vue')
const EditFeaturePage = () => import('@/pages/features/EditFeaturePage.vue')
const EditUserPage = () => import('@/pages/users/EditUserPage.vue')
const UsersPage = () => import('@/pages/users/UsersPage.vue')
const TestUserDataPage = () => import('@/pages/users/TestUserData.vue')
const ClientsPage = () => import('@/pages/clients/ClientsPage.vue')
const EditClientPage = () => import('@/pages/clients/EditClientPage.vue')
const TopicsPage = () => import('@/pages/ontology/topics/TopicsPage.vue')
const TermsPage = () => import('@/pages/ontology/terms/TermsPage.vue')
const CopyV5Analysis = () => import('@/pages/analyses/copy/CopyV5Analysis.vue')
const PastSnapshotsV5Analysis = () => import('@/pages/analyses/snapshots/PastSnapshotsAnalysis.vue')
const CopyDmxAnalysis = () => import('@/pages/analyses/copy/CopyDmxAnalysis.vue')
const ChangelogList = () => import('@/pages/changelogs/ChangelogListView.vue')
const Changelog = () => import('@/pages/changelogs/Changelog.vue')
const ReleasePage = () => import('@/pages/infrastructure/release/ReleasePage.vue')
const ReleaseLogsList = () => import('@/pages/infrastructure/release/ReleaseLogsPage.vue')
const ReleaseLogView = () => import('@/pages/infrastructure/release/ReleaseLogView.vue')
const IpWhitelisting = () => import('@/pages/infrastructure/IpWhitelisting.vue')
const DataSyncList = () => import('@/pages/infrastructure/DataSyncList.vue')
const InstanceSchedulesList = () => import('@/pages/infrastructure/instances_scheduler/InstanceSchedulesList.vue')
const NewInstanceSchedulePage = () => import('@/pages/infrastructure/instances_scheduler/NewInstanceSchedulePage.vue')
const EditInstanceSchedulePage = () => import('@/pages/infrastructure/instances_scheduler/EditInstanceSchedulePage.vue')
const AccessKeys = () => import('@/pages/access_keys/AccessKeys.vue')
const UserSettings = () => import('@/pages/user_settings/UserSettings.vue')
const UserRolesPage = () => import('@/pages/users/UserRolesPage.vue')
const EditUserRolesPage = () => import('@/pages/users/EditUserRolesPage.vue')
const RoleTemplatePage = () => import('@/pages/users/RoleTemplatePage.vue')
const SicSectorPage = () => import('@/pages/sectors/sics/SicSectorPage.vue')
const OrganizationsPage = () => import('@/pages/organizations/OrganizationsPage.vue')
const OrganizationViewPage = () => import('@/pages/organizations/OrganizationViewPage.vue')
const MergeOrganizationsPage = () => import('@/pages/organizations/MergeOrganizationsPage.vue')
const NewsUrlFiltersPage = () => import('@/pages/news_url_filters/NewsUrlFiltersPage.vue')
const NewsWebsourcesPage = () => import('@/pages/news_websources/NewsWebsourcesPage.vue')
const LoginSettings = () => import('@/pages/marketing/LoginSettings.vue')
const UpdateGriSasbMappingsPage = () => import('@/pages/ontology_deployment/UpdateGriSasbMappingsPage.vue')
const UpdateIssueMappingsPage = () => import('@/pages/ontology_deployment/UpdateIssueMappingsPage.vue')
const DeployOntologyPage = () => import('@/pages/ontology_deployment/DeployOntologyPage.vue')
const GriSasbMappings = () => import('@/pages/ontology/gri_sasb/GriSasbMappings.vue')
const PipelineOperationsPage = () => import('@/pages/ontology_deployment/pipeline_operations/PipelineOperationsPage.vue')
const PipelineOperationView = () => import('@/pages/ontology_deployment/pipeline_operations/PipelineOperationView.vue')
const AddSSOPage = () => import('@/pages/clients/AddSSO.vue')
const InitiativeStatisticsHomePage = () => import('@/pages/regulations/initiatives/InitiativeStatisticsHomePage.vue')
const SearchDataConsistencyPage = () => import('@/pages/regulations/initiatives/SearchDataConsistencyPage.vue')
const LinkedCuratedSearchesPage = () => import('@/pages/regulations/linked_curated_searches/LinkedCuratedSearchesPage.vue')
const RegulationSearchSynonymsPage = () => import('@/pages/regulations/regulation_search_synonyms/RegulationSearchSynonymsPage.vue')

import IROroutes from '@/pages/iro/routes.js'
import pipelineMonitoringRoutes from '@/pages/pipeline_monitoring/routes.js'
import statisticsRoutes from '@/pages/statistics/routes.js'
import { ONTOLOGY_ROUTES } from '@/pages/ontology/ontologyRouter.js'
import { DOCUMENT_ROUTES } from '@/pages/document/documentRouter.js'
import { COMPARISON_REPORT_ROUTES } from '@/pages/comparison_report/router.js'

const routes = [
	...statisticsRoutes,
	...pipelineMonitoringRoutes,
	...IROroutes,
	{
		path: '/',
		component: HomePage
	},
	{
		path: '/add-sso/:_id',
		component: AddSSOPage,
		props: (route) => ({
			...route.params,
			permission: ['clients', 'w']
		})
	},
	{
		path: '/news_volume_list',
		component: NewsVolumeList,
		props: {
			permission: ['news_dashboard', 'r']
		}
	},
	{
		path: '/news_explorer/',

		component: NewsExplorer,
		props: (route) => ({
			...route.params,
			permission: ['news_dashboard', 'r']
		})
	},
	{
		path: '/topic_week_stories/:topic_cd/:week_num',
		component: TopicWeeklyStories,
		props: (route) => ({
			...route.params,
			permission: ['news_dashboard', 'r']
		})
	},
	{
		path: '/news_org_peak_stories_6_weeks/:org_id',

		component: NewsOrgsWeeklyStatsBase,
		props: (route) => ({
			...route.params,
			permission: ['news_dashboard', 'r']
		})
	},

	{
		path: '/news_org_stories_2_weeks/:org_id',
		component: NewsOrgsWeeklyStatsBaseLastWeeks,
		props: (route) => ({
			...route.params,
			permission: ['news_dashboard', 'r']
		})
	},
	{
		path: '/news_orgweekly_stats_extens/:org_id/:week_number',
		component: NewsOrgsWeeklyStatsExtended,
		props: (route) => ({
			...route.params,
			permission: ['news_dashboard', 'r']
		})
	},
	{
		path: '/concepts',
		component: ConceptsPage,
		props: { edit: true, permission: ['factors', 'w'] }
	},
	{
		path: '/conceptsView',
		component: ConceptsPage,
		props: {
			edit: false,
			filterBy: '{"status":"live"}'
		}
	},
	{
		path: '/issuers',
		component: IssuersPage,
		props: {
			permission: ['issuers', 'r']
		}
	},
	{
		path: '/issuer/:issuer_id',
		component: IssuerViewPage,
		props: (route) => ({
			...route.params,
			permission: ['issuers', 'r']
		})
	},
	{
		path: '/issuer',
		component: IssuerViewPage,
		props: {
			permission: ['issuers', 'r']
		}
	},
	{
		path: '/regional_unions',
		component: RegionalUnionsPage,
		props: {
			permission: ['regional_unions', 'r']
		}
	},
	{
		path: '/regional_union/:name',
		component: RegionalUnionsViewPage,
		props: (route) => ({
			...route.params,
			permission: ['regional_unions', 'r']
		})
	},
	{
		path: '/regional_union',
		component: RegionalUnionsViewPage,
		props: {
			permission: ['regional_unions', 'w']
		}
	},
	{
		path: '/initiatives_draft',
		component: InitiativesHomePage,
		props: {
			permission: ['initiatives', 'r']
		}
	},
	{
		path: '/initiatives',
		component: ValidatedInitiativesPage,
		props: {
			permission: ['initiatives', 'r']
		}
	},
	{
		path: '/initiative/:init_id',
		component: InitiativeViewPage,
		props: (route) => ({
			...route.params,
			permission: ['initiatives', 'r']
		})
	},
	{
		path: '/deployments',
		component: DeploymentsPage,
		props: (route) => ({
			...route.params,
			permission: ['deployments', 'r']
		})
	},
	{
		path: '/deployment_alerts',
		component: DeploymentAlertsPage
	},
	{
		path: '/deployment_alert_new',
		component: DeploymentAlertsView
	},
	{
		path: '/instances',
		component: InstancesPage,
		props: {
			permission: ['instances', 'r']
		}
	},
	{
		path: '/features',
		component: FeaturesPage,
		props: {
			permission: ['features', 'r']
		}
	},
	{
		path: '/roles',
		component: UserRolesPage,
		props: {
			permission: ['roles', 'r']
		}
	},
	{
		path: '/edit-role/:_id?',
		component: EditUserRolesPage,
		props: (route) => ({
			...route.params,
			permission: ['roles', 'r']
		})
	},
	{
		path: '/role-template/:type',
		component: RoleTemplatePage,
		props: (route) => ({
			...route.params,
			permission: ['roles', 'r']
		})
	},
	{
		path: '/edit-feature/:_id',
		component: EditFeaturePage,
		props: (route) => ({
			...route.params,
			permission: ['features', 'w']
		})
	},
	{
		path: '/edit-feature',
		component: EditFeaturePage,
		props: (route) => ({
			...route.params,
			permission: ['features', 'w']
		})
	},
	{
		path: '/ip-whitelisting',
		component: IpWhitelisting,
		props: {
			permission: ['ip_whitelisting', 'r']
		}
	},
	{
		path: '/datasync',
		component: DataSyncList
	},
	{
		path: '/instance_schedules',
		component: InstanceSchedulesList,
		props: {
			permission: ['instance_scheduler', 'r']
		}
	},
	{
		path: '/new_instance_schedule',
		component: NewInstanceSchedulePage,
		props: (route) => ({
			...route.params,
			permission: ['instance_scheduler', 'w']
		})
	},
	{
		path: '/instance_schedules/:_id',
		component: EditInstanceSchedulePage,
		props: (route) => ({
			...route.params,
			permission: ['instance_scheduler', 'r']
		})
	},
	{
		path: '/edit-user',
		component: EditUserPage,
		props: (route) => ({
			...route.params,
			permission: ['users', 'w']
		})
	},
	{
		path: '/edit-user/:_id',
		component: EditUserPage,
		props: (route) => ({
			...route.params,
			permission: ['users', 'r']
		})
	},
	{
		path: '/users',
		component: UsersPage,
		props: {
			permission: ['users', 'r']
		}
	},
	{
		path: '/test-user-data',
		component: TestUserDataPage
	},
	{
		path: '/clients',
		component: ClientsPage,
		props: {
			permission: ['clients', 'r']
		}
	},
	{
		path: '/edit-client',
		component: EditClientPage,
		props: {
			permission: ['clients', 'w']
		}
	},
	{
		path: '/edit-client/:_id',
		component: EditClientPage,
		props: (route) => ({
			...route.params,
			permission: ['clients', 'w']
		})
	},
	{
		path: '/release',
		component: ReleasePage,
		props: {
			permission: ['production_deployment', 'rw']
		}
	},
	{
		path: '/release-logs',
		component: ReleaseLogsList,
		props: {
			permission: ['production_deployment', 'r']
		}
	},

	{
		path: '/release-log/:_id',
		component: ReleaseLogView,
		props: (route) => ({
			...route.params,
			permission: ['production_deployment', 'r']
		})
	},
	{
		path: '/topics',
		component: TopicsPage,
		props: (route) => ({
			...route.params,
			edit: true,
			permission: ['topics', 'w']
		})
	},
	{
		path: '/topicsView',
		component: TopicsPage,
		props: (route) => ({
			...route.params,
			edit: false,
			filterBy: '{ "status": "live" }'
		})
	},
	{
		path: '/terms',
		component: TermsPage,
		props: (route) => ({
			...route.params,
			edit: true,
			permission: ['terms', 'w']
		})
	},
	{
		path: '/termsView',
		component: TermsPage,
		props: (route) => ({
			...route.params,
			edit: false,
			filterBy: '{"active":true}'
		})
	},
	{
		path: '/gri_sasb_mappings',
		component: GriSasbMappings
	},
	{
		path: '/copy-v5-analysis',
		component: CopyV5Analysis,
		props: (route) => ({
			...route.params,
			permission: ['copy_v5_analyses', 'rw']
		})
	},
	{
		path: '/past-snapshots',
		component: PastSnapshotsV5Analysis,
		props: (route) => ({
			...route.params,
			permission: ['past_snapshots', 'rw']
		})
	},
	{
		path: '/copy-dmx-analysis',
		component: CopyDmxAnalysis,
		props: (route) => ({
			...route.params,
			permission: ['copy_dmx_analyses', 'rw']
		})
	},
	{
		path: '/changelogs',
		component: ChangelogList,
		props: (route) => ({
			...route.params,
			permission: ['release_updates', 'r']
		})
	},
	{
		path: '/edit-changelog',
		component: Changelog,
		props: (route) => ({
			...route.params,
			permission: ['release_updates', 'w']
		})
	},
	{
		path: '/edit-changelog/:_id',
		component: Changelog,
		props: (route) => ({
			...route.params,
			permission: ['release_updates', 'w']
		})
	},
	{
		path: '/access-keys',
		component: AccessKeys,
		props: true
	},
	{
		path: '/settings',
		component: UserSettings,
		props: true
	},
	{
		path: '/sicSectors',
		component: SicSectorPage
	},
	{
		path: '/organizations',
		component: OrganizationsPage,
		props: {
			permission: ['organizations', 'r']
		}
	},
	{
		path: '/organization/:org_id',
		component: OrganizationViewPage,
		props: (route) => ({
			...route.params,
			permission: ['organizations', 'r']
		})
	},
	{
		path: '/merge-orgs',
		component: MergeOrganizationsPage,
		props: {
			permission: ['organizations', 'w']
		}
	},
	{
		path: '/news_url_filters',
		component: NewsUrlFiltersPage,
		props: {
			permission: ['news_url_filters', 'r']
		}
	},
	{
		path: '/news_websources',
		component: NewsWebsourcesPage,
		props: {
			permission: ['news_websources', 'rw']
		}
	},
	{
		path: '/update_issue_mappings',
		component: UpdateIssueMappingsPage,
		props: (route) => ({
			...route.params,
			permission: ['ontology_deployment', 'r']
		})
	},
	{
		path: '/deploy_ontology',
		component: DeployOntologyPage,
		props: {
			permission: ['ontology_deployment', 'r']
		}
	},
	{
		path: '/ontology_pipeline_operations',
		component: PipelineOperationsPage,
		props: {
			permission: ['ontology_deployment', 'r']
		}
	},
	{
		path: '/ontology_pipeline_operations/:pipeline/:operation',
		component: PipelineOperationView,
		props: (route) => ({
			...route.params,
			permission: ['ontology_deployment', 'r']
		})
	},
	{
		path: '/login_settings',
		component: LoginSettings,
		props: (route) => ({
			...route.params,
			permission: ['login_image', 'r']
		})
	},
	{
		path: '/update_gri_sasb_mappings',
		component: UpdateGriSasbMappingsPage,
		props: (route) => ({
			...route.params,
			permission: ['ontology_deployment', 'r']
		})
	},

	{
		path: '/initiatives_statistics',
		component: InitiativeStatisticsHomePage
	},
	{
		path: '/initiatives_search_data_consistency',
		component: SearchDataConsistencyPage
	},
	{
		path: '/linked_curated_searches',
		component: LinkedCuratedSearchesPage
	},
	{
		path: '/regulation_search_synonyms',
		component: RegulationSearchSynonymsPage
	},
	...ONTOLOGY_ROUTES,
	...DOCUMENT_ROUTES,
	...COMPARISON_REPORT_ROUTES
]

const router = createRouter({
	history: createWebHashHistory(),
	routes
})

export default router
